import MicroServicesPage from '../aws/MicroServicesPage';

export default function ScpChangelogManagementPage() {
  return MicroServicesPage('aws-customer-portal-scp-changelog-management');
}
